"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppleProxyUpdateCampaignRequestSchema = exports.AppleProxyCampaignListResponseSchema = exports.AppleProxyCampaignResponseSchema = exports.AppleProxyCampaignSchema = exports.AppleProxyBudgetOrderInfoListResponseSchema = exports.AppleProxyBudgetOrderInfoResponseSchema = exports.AppleProxyBudgetOrderSchema = exports.AppleProxySupplySourcesSchema = exports.AppleProxySupplySourceSchema = exports.AppleProxyCampaignServingStateReasonsListSchema = exports.AppleProxyPaymentModelSchema = exports.AppleProxyLocInvoiceDetailsSchema = exports.AppleProxyCountryOrRegionServingStateReasonSchema = exports.AppleProxyCountryOrRegionSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const core_2 = require("./core");
/* Apple validation is deliberately weaker than it could be.
 *
 * For example, using string rather than enum.
 *
 */
const AppleProxyAdChannelTypeSchema = (0, core_1.StringUnion)(["SEARCH", "DISPLAY"], {
    title: "Ad Channel Schema",
    description: "The channel type of ad in a campaign.",
});
const AppleProxyBillingEventSchema = (0, core_1.StringUnion)(["TAPS", "IMPRESSIONS"], {
    title: "Billing Event",
    description: "The type of billing event for a campaign. When supplySources is APPSTORE_SEARCH_RESULTS, the billingEvent must be TAPS. When supplySources is APPSTORE_SEARCH_TAB, the billingEvent must be IMPRESSIONS",
});
exports.AppleProxyCountryOrRegionSchema = typebox_1.Type.String({
    // As this must be an ISO-2 country it could be a StringUnion, however that might change with Apple.
    title: "Country or Regions",
    description: "The App Store geoterritories where you are promoting your app. The default value is US. The field requires an ISO country code value for the locations you are promoting to.",
});
exports.AppleProxyCountryOrRegionServingStateReasonSchema = typebox_1.Type.Record(exports.AppleProxyCountryOrRegionSchema, typebox_1.Type.Array(typebox_1.Type.String()), {
    title: "Country or Region Serving State Reasons Map",
    description: "The map of reasons that returns when a campaign isn't running.",
});
const AppleProxyCountriesOrRegionsSchema = typebox_1.Type.Array(exports.AppleProxyCountryOrRegionSchema);
exports.AppleProxyLocInvoiceDetailsSchema = typebox_1.Type.Object({
    billingContactEmail: (0, core_1.Nullable)(typebox_1.Type.String({
        title: "Billing Contact Email",
        description: "A valid email address for the LOC billing contact.",
    })),
    buyerEmail: (0, core_1.Nullable)(typebox_1.Type.String({
        title: "Buyer Email",
        description: "A valid email address for the LOC buyer.",
    })),
    buyerName: (0, core_1.Nullable)(typebox_1.Type.String({
        title: "Buyer Name",
        description: "A valid LOC buyer name.",
    })),
    clientName: (0, core_1.Nullable)(typebox_1.Type.String({
        title: "Client Name",
        description: "An advertiser or product. Required for agency-type accounts.",
    })),
    orderNumber: (0, core_1.Nullable)(typebox_1.Type.String({
        title: "Order Number",
        description: "A purchase order number. Required for agency-type accounts.",
    })),
}, {
    title: "LOC Invoice Details",
    description: "The response to a request to fetch campaign details for a standard invoicing payment model.",
});
exports.AppleProxyPaymentModelSchema = (0, core_1.StringUnion)(["PAYG", "LOC"], {
    title: "Payment Model",
    description: "The payment model that you set through the Search Ads UI. If you don't set a payment model, campaigns can't run. PAYG is a pay-as-you-go payment model or LOC is a line-of-credit payment model.",
});
// This caused issues even though the list is the complete list described on the website
const AppleProxyCampaignServingStateReasonsSchema = typebox_1.Type.String();
exports.AppleProxyCampaignServingStateReasonsListSchema = (0, core_1.OptionalNullable)(typebox_1.Type.Array(AppleProxyCampaignServingStateReasonsSchema), {
    title: "Campaign Serving State Reasons List",
    description: "A list of reasons that displays when a campaign can't run.",
});
exports.AppleProxySupplySourceSchema = (0, core_1.StringUnion)([
    "APPSTORE_SEARCH_RESULTS",
    "APPSTORE_SEARCH_TAB",
    "APPSTORE_TODAY_TAB",
    "APPSTORE_PRODUCT_PAGES_BROWSE",
], {
    title: "Supply Source",
    description: "The supply source of ads to use in a campaign.",
});
exports.AppleProxySupplySourcesSchema = typebox_1.Type.Array(exports.AppleProxySupplySourceSchema);
const AppleProxyCampaignStatusSchema = (0, core_1.OptionalNullable)(core_2.AppleProxyStatusSchema, {
    title: "Status",
    description: "The user-controlled status to enable or pause the campaign.",
});
const AppleProxyCampaignServingStatusSchema = (0, core_1.OptionalNullable)(core_2.AppleProxyServingStatusSchema, {
    title: "Serving Status",
    description: "The status of the campaign.",
});
const AppleProxyBudgetAmountSchema = typebox_1.Type.Object(ruby_1.AppleProxyMoneySchema.properties, {
    title: "Budget Amount",
    description: "The total budget amount available to the campaign. You can't reduce a budgetAmount after you start a campaign. When you set a budget, your campaign runs until you exhaust your budget, pause your campaign, or reach the scheduled end date.",
});
const AppleProxyDailyBudgetAmountSchema = (0, core_1.OptionalNullable)(ruby_1.AppleProxyMoneySchema, {
    title: "Daily Budget Amount",
    description: "Your daily spend cap. If you reach the daily spend cap, a campaign pauses for the remainder of the day.",
});
const AppleProxyBudgetOrdersSchema = (0, core_1.OptionalNullable)(typebox_1.Type.Array(typebox_1.Type.Integer()), {
    title: "Budget Orders",
    description: "The budget orders that you assign to the campaign. This applies only to campaigns with a line-of-credit payment model. You can also use budget orders to manage how to spend your budget across multiple campaigns.",
});
const AppleProxyDeletedSchema = (0, core_1.OptionalNullable)(typebox_1.Type.Boolean(), {
    title: "Deleted",
    description: "The indicator of whether the campaign is soft-deleted.",
});
const AppleProxyCampaignDisplayStatusSchema = (0, core_1.OptionalNullable)(core_2.AppleProxyDisplayStatusSchema, {
    title: "Display Status",
    description: "The status of the campaign. The status resolves according to servingStatus and additional criteria.",
});
const AppleProxyCampaignEndTimeSchema = (0, core_1.OptionalNullable)(core_2.AppleProxyDateTimeSchema, {
    title: "End Time",
    description: "The scheduled end date and time for the ad group, which the system determines from the ad group with the latest end time in the campaign. If a campaign doesn't have an ad group, the response is null.",
});
const AppleProxyCampaignRefSchema = (0, core_1.OptionalNullable)(ruby_1.AppleProxyRefSchema, {
    title: "ID",
    description: "A unique identifier for the campaign that you can use as a campaignid in endpoint resources.",
});
const AppleProxyCampaignPaymentModelSchema = (0, core_1.OptionalNullable)(exports.AppleProxyPaymentModelSchema, {
    title: "Payment Model Schema",
    description: "The payment model that you set through the Search Ads UI. If you don't set a payment model, campaigns can't run. \
    PAYG - A pay-as-you-go payment model. LOC - A line-of-credit payment model. \
    If you don't select a payment model, you can still create campaigns. You must select a payment model before a campaign is eligible to run.",
});
const AppleProxyCampaignNameSchema = typebox_1.Type.String({
    title: "Campaign Name",
    description: "The name of the campaign, which is unique within an organization.",
});
const AppleProxyCampaignStartTimeSchema = (0, core_1.OptionalNullable)(core_2.AppleProxyDateTimeSchema, {
    title: "Start Time",
    description: "The scheduled start date and time for the campaign, which the system determines from the ad group with the earliest start time in the campaign. If a campaign doesn't have an ad group, the response is null.",
});
const BudgetOrderStatusSchema = (0, core_1.StringUnion)([
    "ACTIVE",
    "CANCELLED",
    "COMPLETED",
    "EXHAUSTED",
    "INACTIVE",
]);
exports.AppleProxyBudgetOrderSchema = typebox_1.Type.Object({
    billingEmail: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    budget: (0, core_1.OptionalNullable)(ruby_1.AppleProxyMoneySchema),
    clientName: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    endDate: (0, core_1.OptionalNullable)(core_2.AppleProxyDateTimeSchema),
    id: (0, core_1.OptionalNullable)(ruby_1.AppleProxyRefSchema),
    name: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    orderNumber: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    paymentOrgId: (0, core_1.OptionalNullable)(ruby_1.AppleProxyOrgRefSchema),
    primaryBuyerEmail: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    primaryBuyerName: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    startDate: (0, core_1.OptionalNullable)(core_2.AppleProxyDateTimeSchema),
    status: (0, core_1.OptionalNullable)(BudgetOrderStatusSchema),
    supplySources: (0, core_1.OptionalNullable)(exports.AppleProxySupplySourcesSchema),
});
const AppleProxyBudgetOrderInfoSchema = typebox_1.Type.Object({
    bo: (0, core_1.OptionalNullable)(exports.AppleProxyBudgetOrderSchema),
});
exports.AppleProxyBudgetOrderInfoResponseSchema = typebox_1.Type.Object({
    data: (0, core_1.OptionalNullable)(AppleProxyBudgetOrderInfoSchema),
    error: (0, core_1.OptionalNullable)(core_2.AppleProxyErrorResponseBodySchema),
    pagination: (0, core_1.OptionalNullable)(core_2.AppleProxyPageDetailSchema),
});
exports.AppleProxyBudgetOrderInfoListResponseSchema = typebox_1.Type.Object({
    data: (0, core_1.OptionalNullable)(typebox_1.Type.Array(AppleProxyBudgetOrderInfoSchema)),
    error: (0, core_1.OptionalNullable)(core_2.AppleProxyErrorResponseBodySchema),
    pagination: (0, core_1.OptionalNullable)(core_2.AppleProxyPageDetailSchema),
});
exports.AppleProxyCampaignSchema = typebox_1.Type.Object({
    adamId: core_2.AppleProxyAdamRefSchema,
    adChannelType: AppleProxyAdChannelTypeSchema,
    billingEvent: AppleProxyBillingEventSchema,
    budgetAmount: (0, core_1.OptionalNullable)(AppleProxyBudgetAmountSchema),
    budgetOrders: AppleProxyBudgetOrdersSchema,
    countriesOrRegions: (0, core_1.OptionalNullable)(AppleProxyCountriesOrRegionsSchema),
    countryOrRegionServingStateReasons: (0, core_1.OptionalNullable)(exports.AppleProxyCountryOrRegionServingStateReasonSchema),
    dailyBudgetAmount: AppleProxyDailyBudgetAmountSchema,
    deleted: AppleProxyDeletedSchema,
    displayStatus: AppleProxyCampaignDisplayStatusSchema,
    endTime: AppleProxyCampaignEndTimeSchema,
    id: AppleProxyCampaignRefSchema,
    locInvoiceDetails: (0, core_1.OptionalNullable)(exports.AppleProxyLocInvoiceDetailsSchema),
    modificationTime: (0, core_1.OptionalNullable)(core_2.AppleProxyModificationTimeSchema),
    name: AppleProxyCampaignNameSchema,
    orgId: (0, core_1.OptionalNullable)(ruby_1.AppleProxyOrgRefSchema),
    paymentModel: AppleProxyCampaignPaymentModelSchema,
    sapinLawResponse: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    servingStateReasons: exports.AppleProxyCampaignServingStateReasonsListSchema,
    servingStatus: AppleProxyCampaignServingStatusSchema,
    startTime: AppleProxyCampaignStartTimeSchema,
    status: AppleProxyCampaignStatusSchema,
    supplySources: (0, core_1.OptionalNullable)(exports.AppleProxySupplySourcesSchema),
}, {
    title: "Campaign",
    description: "The response to a request to create and fetch campaigns.",
});
exports.AppleProxyCampaignResponseSchema = typebox_1.Type.Object({
    data: (0, core_1.Nullable)(exports.AppleProxyCampaignSchema, {
        title: "Data",
        description: "Response data that the API provides.",
    }),
    error: (0, core_1.OptionalNullable)(core_2.AppleProxyErrorResponseBodySchema, {
        title: "Error",
        description: "Error response data that the API provides.",
    }),
    pagination: (0, core_1.OptionalNullable)(core_2.AppleProxyPageDetailSchema, {
        title: "Pagination",
        description: "Page detail information that the API provides.",
    }),
});
exports.AppleProxyCampaignListResponseSchema = typebox_1.Type.Object({
    data: (0, core_1.OptionalNullable)(typebox_1.Type.Array(exports.AppleProxyCampaignSchema), {
        title: "Data",
        description: "Response data that the API provides.",
    }),
    error: (0, core_1.OptionalNullable)(core_2.AppleProxyErrorResponseBodySchema, {
        title: "Error",
        description: "Error response data that the API provides.",
    }),
    pagination: (0, core_1.OptionalNullable)(core_2.AppleProxyPageDetailSchema, {
        title: "Pagination",
        description: "Page detail information that the API provides.",
    }),
}, {
    title: "Campaign Response",
    description: "A container for the campaign response body.",
});
const AppleProxyCampaignUpdateSchema = typebox_1.Type.Object({
    budgetAmount: (0, core_1.OptionalNullable)(ruby_1.AppleProxyMoneySchema),
    budgetOrders: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.AppleProxyRefSchema)),
    countriesOrRegions: typebox_1.Type.Optional(AppleProxyCountriesOrRegionsSchema),
    dailyBudgetAmount: (0, core_1.OptionalNullable)(ruby_1.AppleProxyMoneySchema),
    locInvoiceDetails: typebox_1.Type.Optional(exports.AppleProxyLocInvoiceDetailsSchema),
    name: typebox_1.Type.Optional(typebox_1.Type.String()),
    status: typebox_1.Type.Optional(core_2.AppleProxyStatusSchema),
});
exports.AppleProxyUpdateCampaignRequestSchema = typebox_1.Type.Object({
    campaign: typebox_1.Type.Optional(AppleProxyCampaignUpdateSchema),
    clearGeoTargetingOnCountryOrRegionChange: (0, core_1.OptionalNullable)(typebox_1.Type.Boolean()),
});
